module.exports = __webpack_public_path__ + "media/images/noimage-writer@2x-d9237e4d6fae0eab77e791b8370c9dcb.png";